import { action } from 'typesafe-actions';

import { CompanyConfiguration } from 'models/company';
import { Response } from 'models/response';
export const COMPANY_CONFIGURATION_REQUEST = 'COMPANY_CONFIGURATION_REQUEST';
export const COMPANY_CONFIGURATION_SUCCESSFUL = 'COMPANY_CONFIGURATION_SUCCESSFUL';
export const COMPANY_CONFIGURATION_FAILURE = 'COMPANY_CONFIGURATION_FAILURE';

export const companyConfigurationRequest = () => action(COMPANY_CONFIGURATION_REQUEST);

export const companyConfigurationSuccessful = ({ data }: Response<CompanyConfiguration>) =>
  action(COMPANY_CONFIGURATION_SUCCESSFUL, { configuration: data });

export const companyConfigurationError = (error: string) => action(COMPANY_CONFIGURATION_FAILURE, error);
